import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { UserEvent } from "../../Types";

export const apiCallGetUserEvents = async ({
  userId,
  limit
}: {
  userId: number;
  limit: number;
}): Promise<{
  data: { eventsData: UserEvent[]; breachesData: UserEvent[] };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    userEvents: UserEvent[];
    breachesEvents: UserEvent[];
  }>(`user/getUserEvents`, {
    userId,
    limit
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        eventsData: data.userEvents,
        breachesData: data.breachesEvents
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { eventsData: [], breachesData: [] },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { eventsData: [], breachesData: [] },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
